// extracted by mini-css-extract-plugin
module.exports = {"ContactConfirmation":"ContactConfirmation_ContactConfirmation__IWciK","Icon":"ContactConfirmation_Icon__suuBS","Title":"ContactConfirmation_Title__34k99"};